/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-camper-dcd97714--sprite",
  "use": "car-camper-dcd97714--sprite-usage",
  "viewBox": "0 0 47 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 47 29\" id=\"car-camper-dcd97714--sprite\"><path d=\"M40 14h1a5 5 0 015 5v4a1 1 0 01-1 1h-5m0-10l-6-8m6 8h-7.5a1 1 0 01-1-1V6M34 6h-2.5M34 6h5a1 1 0 001-1V2a1 1 0 00-1-1H2a1 1 0 00-1 1v4m39 18a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H14m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H2a1 1 0 01-1-1V6m30.5 0H1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M28.5 6v15m0 0H21m7.5 0H33m-12 0V6m0 15h-8.5M7 21H1m38 0h6.5M1 16h3v2H1.5M46 17h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
